<div class="internal-chat-info" title="{{ chat.chat.name }}">
  <div class="internal-chat-info_avatar">
    <internal-chat-s3-image [avatarName]="chat.chat.name"></internal-chat-s3-image>
  </div>
  <span class="internal-chat-info_name">{{ chat.chat.name }}</span>
  <internal-messages-counter *ngIf="unreadMessages" [unreadMessages]="unreadMessages"></internal-messages-counter>
</div>
